import React, { useState, useEffect } from "react";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import { useGetManufacturerByIdQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import BuyAndSell from "features/Procurement/common/BuyAndSell";
const ProjectProcurementParentComponnet = ({ orgId, activeTabProject,setActiveTabProject,showHeader}) => {
  const RolesFromToken = useSelector(selectCurrentRoles);
  // console.log("RolesFromToken",RolesFromToken)
  //  let id=orgId?orgId:RolesFromToken.organization_id;
  let id = orgId ? orgId : RolesFromToken.organization_id;
  //  const { data: data } = useGetManufacturerByIdQuery({ id, organization_type });
  const [organizationVal, setOrganizatinVal] = useState({procurement_type:"Seller"});
  // useEffect(()=>{
  //    if(data){
  //     setOrganizatinVal(data?.data)
  //    }
  // },[data])
  return (
    <div>
      <BuyAndSell organizationVal={organizationVal} activeTabProject={activeTabProject} projectOrgId={id} setActiveTabProject={setActiveTabProject} showHeader={showHeader}/>
    </div>
  );
};

export default ProjectProcurementParentComponnet;
